export default __webpack_public_path__ + "static/1@2x-a38eb4d47d05faa944fdbcab63a14649.png";